import { ServiceLocation, UserDetails } from 'src/api/@generated/backend-api';

class OrderInformationUtils {
  public static getShortAddress(serviceLocation: ServiceLocation): string {
    const { address } = serviceLocation;

    return `${address.streetAddress || address.streetAddress2}`;
  }

  public static getFullAddress(serviceLocation: ServiceLocation): string {
    const {
      address: { streetAddress, streetAddress2, postalCode, city, dwellingUnitNumber },
    } = serviceLocation;

    const showDwellingUnitNumber = dwellingUnitNumber ? `${dwellingUnitNumber},` : '';

    return `${streetAddress || streetAddress2}, ${showDwellingUnitNumber} ${postalCode} ${city}`;
  }

  public static getFullName(user: UserDetails): string {
    return `${user.firstName} ${user.lastName}`;
  }
}

export { OrderInformationUtils };
